import React from 'react';

import '../styles/EspaceAdherent.css';
import '../styles/Root.css';
import construction from '../assets/construction.png';

const EspaceAdherent = () => {
  return (
    <main>
      <section className="hero fade-in">
        <h1>Espace Adhérent</h1>
        <p>Bienvenue dans votre espace adhérent</p>
      </section>

      <section className="content-section fade-in">
        <img
          src={construction}
          alt="Révision"
          className="img-feature"
        />
        <h2>Message Important</h2>
        <p>
          Cette page est actuellement en travaux dans le but de vous apporter de nouvelles fonctionnalités.
          Merci pour votre patience et pour votre compréhension.
        </p>
        <p>
          En attendant, vous pouvez continuer à explorer notre site et découvrir
          nos collections, nos conférences, et bien plus encore. N'hésitez pas à
          nous contacter si vous avez des questions ou des suggestions.
        </p>
      </section>
    </main>
  );
};

export default EspaceAdherent;
